import styled, { css } from 'styled-components';

import { FilestackImageData } from 'api/types/shared.types';
import { breakpoints, colors } from 'theme';
import { imageUrl } from 'utils/filestack';
import { retinaBackgroundImage } from 'utils/style';

const filestackTransform = (width: number, height: number) =>
  `resize=w:${width},h:${height}/quality=value:70`;

export const BannerContainer = styled.div<{
  image: FilestackImageData;
  mobileImage: FilestackImageData;
  requestIsAmp: boolean;
  convert: boolean;
}>`
  height: 100%;
  background-color: ${colors.battleshipGrey};
  background-size: cover;
  background-position: center;
  ${({ image, mobileImage, convert }) =>
    mobileImage || image
      ? retinaBackgroundImage(
          imageUrl({
            handle: mobileImage ? mobileImage.handle : image && image.handle,
            mimetype: mobileImage
              ? mobileImage.mimetype
              : image && image.mimetype,
            transform: filestackTransform(992, 605),
            format: convert ? 'jpg' : undefined,
          }),
          {
            filename2x: imageUrl({
              handle: mobileImage ? mobileImage.handle : image && image.handle,
              mimetype: mobileImage
                ? mobileImage.mimetype
                : image && image.mimetype,
              transform: filestackTransform(1984, 1210),
              format: convert ? 'jpg' : undefined,
            }),
            include3x: false,
          }
        )
      : css`
          background-image: none;
        `}
  @media (min-width: ${breakpoints[2]}) {
    ${({ image, convert }) =>
      image
        ? retinaBackgroundImage(
            imageUrl({
              handle: image.handle,
              mimetype: image.mimetype,
              transform: filestackTransform(1920, 1024),
              format: convert ? 'jpg' : undefined,
            }),
            {
              filename2x: imageUrl({
                handle: image.handle,
                mimetype: image.mimetype,
                transform: filestackTransform(2400, 1152),
                format: convert ? 'jpg' : undefined,
              }),
              include3x: false,
            }
          )
        : css`
            background-image: none;
          `}
  }
  img {
    display: none;
    height: 100%;
    width: 100%;
  }
  ${(props) =>
    props.requestIsAmp
      ? ''
      : `
  @supports (object-fit: cover) {
    background-image: none;
    img {
      display: block;
      object-fit: cover;
    }
  }`}
`;
